export default __webpack_public_path__ + "static/media/TheRecharge_Neoncar00057.72b5540c.png";